<script>
  import {VueMaskDirective as mask} from 'v-mask'
  import service from '../../../../domain/retirada/services'
  import { mapGetters } from 'vuex'

  export default {
    nome: 'visualizar-pendencias-lote',
    props: {
      documentoLiberacao: {
        type: String,
        required: true
      },
      tipoDocumentoLiberacao: {
        required: true
      },
      grv: {
        required: true
      }
    },
    directives: {mask},
    data () {
      return {
        lote: null,
        isUploadingFoto: false,
        lances: null,
        lancesLoading: false,
        videoDestaque: ''
      }
    },
    computed: {
      ...mapGetters(['isLogged', 'currentUser'])
    },
    mounted () {
    },
    activated () {
    },
    created () {
      this.$loaderOverlay.open().message('Aguarde enquanto carregamos os dados...')
      service.verificarPendenciasVeiculo(this.grv, this.tipoDocumentoLiberacao, this.documentoLiberacao)
        .then(response => {
          this.$loaderOverlay.hide()
          this.lote = response.data
          console.log(response.data)
        })
        .catch(error => {
          this.$loaderOverlay.hide()
          alert('Erro ao obter os dados')
          console.log(error)
        })
    },
    beforeDestroy () {},
    deactivated () {
      this.$destroy() // no keep-alive
    },
    watch: {},
    methods: {
      round: function (number, precision) {
        let factor = Math.pow(10, precision)
        let tempNumber = number * factor
        let roundedTempNumber = Math.round(tempNumber)
        return roundedTempNumber / factor
      },
      print: function () {
        window.print()
      },
      adjustFirstLetter (v) {
        return v.charAt(0).toLowerCase() + v.slice(1)
      }
    }
  }
</script>

<template>
  <transition name="slide">
    <div v-if="lote !== null" class="content-transition">
      <div class="fade-in-down">
        <!--<div class="bg-light lter b-b wrapper-md">
          <div class="row">
            <div class="col-md-6">
              <h1 class="m-n font-thin h3">Lote #{{ lote }}</h1>
              <h1 class="m-n font-thin h3">{{ lote.titulo }}</h1>
            </div>
            <div class="col-md-6"></div>
          </div>
        </div>-->
        <div class="wrapper-md">
          <div class="row">
            <div class="col-xs-12 col-md-12">
              <p>
                Multas: <strong>{{ lote.QuantidadeMultas }}</strong> <br>
                Indicação Débitos Dad: <strong>{{ lote.IndicacaoDebitosDad }}</strong> <br>
                Indicação Débitos Seguro: <strong>{{ lote.IndicacaoDebitosSeguro }}</strong> <br>
                Indicação Débitos Vistoria: <strong>{{ lote.IndicacaoDebitosVistoria }}</strong> <br>
              </p>

              <p class="m-t-lg">
                Débitos IPVA:<br>
              </p>
              <div v-for="debito in (lote.DebitoIpva || []).filter(item => item)">
                - <strong>{{ debito }}</strong><br>
              </div>
              <p class="m-t-lg">
                Cod Sub Restrições Administrativas:<br>
              </p>
              <div v-for="debito in (lote.CodSubRestricoesAdministrativas || []).filter(item => item)">
                - <strong>{{ debito }}</strong><br>
              </div>
              <p class="m-t-lg">
                Cod Sub Restrições Jurídicas:<br>
              </p>
              <div v-for="debito in (lote.CodSubRestricoesJudicias || []).filter(item => item)">
                - <strong>{{ debito }}</strong><br>
              </div>
              <p class="m-t-lg">
                Pendências:<br>
              </p>
              <div v-for="debito in (lote.DescricaoPendencias || []).filter(item => item)">
                - <strong>{{ debito }}</strong><br>
              </div>
              <p class="m-t-lg">
                Restrições Administrativas:<br>
              </p>
              <div v-for="debito in (lote.RestricoesAdministrativas || []).filter(item => item)">
                - <strong>{{ debito }}</strong><br>
              </div>
              <p class="m-t-lg">
                Restrições Judiciais:<br>
              </p>
              <div v-for="debito in (lote.RestricoesJudiciais || []).filter(item => item)">
                - <strong>{{ debito }}</strong><br>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>



// WEBPACK FOOTER //
// VisualizarPendenciasVeiculo.vue?692efc5a